import { render, staticRenderFns } from "./MatchingCard.vue?vue&type=template&id=aa8b2432"
import script from "./MatchingCard.vue?vue&type=script&lang=js"
export * from "./MatchingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports